import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories.component.html',
  styleUrls: ['./success-stories.component.scss']
})
export class SuccessStoriesComponent implements OnInit {

  selectedLang: any;

  constructor(
    private translateService: TranslateService,
    private location: Location
  ) { }

  ngOnInit(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // if (localStorage.getItem('lang')) {
    //   this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
    //   this.translateService.use(this.selectedLang.code)
    // }
  }

  onChildValueChanged(value){
    // console.log(value)
    // if (value?.code == 'en') {
    //   // this.lanTranslate('en')
    // } else if (value?.code == 'hd') {
    //   // this.lanTranslate('hd')
    // }
  }

  goBack(): void {
    this.location.back();
  }

}

